export enum DateFormatType {
    short = 'short',
    long = 'long',
}
